/**
 * @file User / material analysis UI — pages/Dashboard/User/UserDashboard.tsx.
 */

import React, { useState } from "react";
import DashboardHeader from "../../../components/Layout/DashboardHeader";
import DashboardFooter from "../../../components/Layout/DashboardFooter";
import SidebarUser from "../../../components/Layout/SidebarUser";
import "./UserDashboard.css";
import UserProfile from "./Profile/UserProfile";

// NEW IMPORTS
import MaterialAnalysisInput from "./MaterialAnalysisInput/MaterialAnalysisInput";
import MaterialLibrary from "./MaterialLibrary/MaterialLibrary";
import UserHome from "./Home/UserHome";

const UserDashboard: React.FC = () => {
  const [activeSection, setActiveSection] = useState("Home");



  const renderContent = () => {
    switch (activeSection) {
      case "Home":
        return (
          <UserHome 
            onNavigateToMaterialAnalysis={() => setActiveSection("Material Analysis")}
          />
        );

      case "Profile":
        return <UserProfile />;

      case "Material Library":
        return <MaterialLibrary />;

      case "Material Analysis":
        return <MaterialAnalysisInput />;

      default:
        return (
          <div>
            <h2 className="dashboard-section-title">{activeSection}</h2>
          </div>
        );
    }
  };

  return (
    <div className="dashboard-container">
      <DashboardHeader />

      <div className="dashboard-body">
        <SidebarUser
          onSelect={(section) => {
            setActiveSection(section);
          
          }}
          activeSection={activeSection}
        />

        <main className="dashboard-content">
          <div className="content-wrapper">{renderContent()}</div>
        </main>
      </div>

      <DashboardFooter />
    </div>
  );
};

/** React component — User Dashboard. */
export default UserDashboard;
